import pythonLogo from "../../assets/images/pythonLogo.png";
import htmlLogo from "../../assets/images/htmlLogo.png";
import scratchLogo from "../../assets/images/vc3 logo.png";
import vcJrLogo from "../../assets/images/vc jr logo.png";
import jsLogo from "../../assets/images/jsLogo.png";
import sqlLogo from "../../assets/images/sqlLogo.png";
import geekyBirdLogo from "../../assets/images/geekyBirdLogo.png";
import geekyBirdLogoProgrammable from "../../assets/images/geekyBirdLogoProgrammable.png";
import codeCompatLogo from "../../assets/images/codeCompat.png";
import danceMatLogo from "../../assets/images/dancemat.png";
import ninjaLogo from "../../assets/images/ninjaLogo.png";
import webtypistLogo from "../../assets/images/typing.png";
import mitLogo from "../../assets/images/mitLogo.png";
import makeCodeLogo from "../../assets/images/makecode_logo.png";
import { global_var } from "../../services/cs-lab-config";
import ReactGA from "react-ga4";

const projectStackMetaMapping = {
  html_css: {
    logo: htmlLogo,
    route: "/htmlcsside/",
    projectStackDisplayName: "HTML",
    defaultFileName: "index.html",
    showLabQuestion : true,
    createProjectsInProjects: true,
    description:
      "The HyperText Markup Language or HTML is the standard markup language for documents designed to be displayed in a web browser.",
    coverColor:'#7090F5',
    tutorialVideoUrl: 'https://www.youtube.com/embed/Ztq_4jmzriY?si=uj4OvOm6lMMz7Wxk'
  },
  python: {
    logo: pythonLogo,
    route: "/pythonide/",
    projectStackDisplayName: "Python",
    defaultFileName: "main.py",
    showLabQuestion : true,
    createProjectsInProjects: true,
    description:
      "Python is a high-level, general-purpose programming language.",
    coverColor:'#7090F5',
    tutorialVideoUrl: 'https://www.youtube.com/embed/rxt9cqiqE8o?si=MuKl1JmtDdCIsi-k'
  },
  scratch: {
    logo: scratchLogo,
    projectStackDisplayName: "Scratch",
    description:
      "Scratch is a high-level block-based visual programming language and website aimed primarily at children as an educational tool, with a target audience of ages 8 to 16.",
    coverColor:'#D7BEF7'
  },
  vc3: {
    logo: scratchLogo,
    projectStackDisplayName: "Visual Coding 3",
    route: "/vc3/",
    showLabQuestion : true,
    description:
      "Visual coding is a high-level block-based visual programming language and website aimed primarily at children as an educational tool, with a target audience of ages 8 to 16.",
    coverColor:'#D7BEF7',
    tutorialVideoUrl: 'https://www.youtube.com/embed/gZlhglCmOZg?si=2DEskO2tIETLvF5b'
  },
  scratchjr: {
    logo: vcJrLogo,
    projectStackDisplayName: "Visual Coding Jr",
    route: "/scratchjr/",
    description:
      "Visual Coding Jr is a visual programming language designed to introduce programming skills to children ages 5–7.",
    coverColor:'#D7BEF7',
    tutorialVideoUrl: 'https://www.youtube.com/embed/wKyD9yRp_gs?si=UFVrxHIzVlnNl_sw'
  },
  javascript: {
    logo: jsLogo,
    route: "/htmlcsside/",
    projectStackDisplayName: "JavaScript",
    description:
      "JavaScript, often abbreviated as JS, is a programming language that is one of the core technologies of the World Wide Web.",
    coverColor:'#FEF8F8',
  },
  sql2: {
    logo: sqlLogo,
    projectStackDisplayName: "SQL",
    route: "/sqlide/",
    showLabQuestion : true,
    description:
      "Structured Query Language, is a domain-specific language used in programming and designed for managing data held in a relational database management system.",
    coverColor:'#FEF8F8',
    tutorialVideoUrl: 'https://www.youtube.com/embed/f-7lsZjs1lM?si=SIwM77EggUC0vO2w'    
  },
  codeCombat_game: {
    logo: codeCompatLogo,
    route: "/codecompat/",
    hideMyProjects: true,
    projectStackDisplayName: "CodeCombat Game",
    description:
      "CodeCombat is an educational video game for learning software programming concepts and languages.",
    coverColor:'#7090F5',
  },
  geekyBird_game: {
    logo: geekyBirdLogo,
    route: "/geekybird/",
    hideMyProjects: true,
    projectStackDisplayName: "Geeky Bird Game",
    description:
      "Players can control the bird's flight by answering math questions correctly, making learning an enjoyable adventure",
    coverColor:'#7090F5',
  },
  geekyBird_game_programmable: {
    logo: geekyBirdLogoProgrammable,
    route: "/geekybirdpr/",
    hideMyProjects: true,
    projectStackDisplayName: "Geeky Bird Game Programmable",
    description:
      "This is a customizable web-based game that allows players to personalize the appearance of their in-game bird character.",
    coverColor:'#7090F5',
  },
  dance_mat_typing: {
    logo: danceMatLogo,
    route: "/dancemat/",
    hideMyProjects: true,
    projectStackDisplayName: "Dance Mat Typing",
    description:
      "Dance Mat is great fun! It shows us how to type using the correct fingers.",
    coverColor:'#D7BEF7',
  },
  typing_ninja: {
    logo: ninjaLogo,
    route: "/typingninja/",
    hideMyProjects: true,
    projectStackDisplayName: "Typing Ninja",
    description:
      "Typing Ninja gives you easy, medium, or hard typing practice so you can improve your typing skills.",
    coverColor:'#D7BEF7',
  },
  web_typist: {
    logo: webtypistLogo ,
    route: "/webtypist/",
    projectStackDisplayName: "CS Typing Tutor",
    defaultFileName: "typing",
    createProjectsInProjects: true,
    description:
    "CS Typing Tutor makes learning fun and helps you develop proper finger placement.",
    coverColor:'#D7BEF7',
    },
  mit_app_inventor: {
    logo: mitLogo,
    hideMyProjects: true,
    route : "/mit/",
    projectStackDisplayName: "Mit App Inventor",
    description:
      "MIT App Inventor is a high-level block-based visual programming language, originally built by Google and now maintained by the Massachusetts Institute of Technology.",
    coverColor:'#D7BEF7',
  },
  makecode: {
    logo: makeCodeLogo,
    route: "/makecode/",
    // openInNewTab: true,
    projectStackDisplayName: "makeCode",
    description:
      "MakeCode is a platform for creating engaging computer science learning experiences that support a progression path into real-world programming.",
    coverColor:'#FFECD2',
  },
};

const evaluationStatusMetaMapping = {
  Evaluated: {
    color: "#2AC14E",
  },
  "Ask for resubmission": {
    color: "#7090F5",
    displayName: "Asked to resubmit",
  },
};

function getEvaluationStatusColor(evaluationStatus) {
  return evaluationStatusMetaMapping[evaluationStatus]
    ? evaluationStatusMetaMapping[evaluationStatus].color
      ? evaluationStatusMetaMapping[evaluationStatus].color
      : "#7090F5"
    : "#E96358";
}

function getEvaluationStatusName(evaluationStatus) {
  if (!evaluationStatus) {
    return "Pending Evaluation";
  }

  return evaluationStatusMetaMapping[evaluationStatus]
    ? evaluationStatusMetaMapping[evaluationStatus].displayName
      ? evaluationStatusMetaMapping[evaluationStatus].displayName
      : evaluationStatus
    : evaluationStatus;
}

function getFileExtension(filename) {
  // Split the filename by the dot (.)
  const parts = filename.split(".");

  // Get the last part of the split string (which is the extension)
  const extension = parts[parts.length - 1];

  // Return the extension in lowercase (optional)
  return extension.toLowerCase();
}

function formatDate(date_) {
  date_ = new Date(date_ + "Z");

  return `${date_.toLocaleString("en-US", {
    month: "long",
  })} ${date_.getDate()}, ${date_.getFullYear()} at ${date_.toLocaleString(
    "en-US",
    { hour: "numeric", minute: "numeric", hour12: true }
  )}`;
}

function formatDateMonth(date_) {
  date_ = new Date(date_);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIndex = date_.getMonth();
  const day = date_.getDate();
  const year = date_.getFullYear();

  return `${months[monthIndex]} ${day}, ${year}`;
}

function getIdeProjectTypeMetaData(projectStack) {
  return projectStackMetaMapping[projectStack];
}
function getShowMyProjectFlag(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].hideMyProjects
    : false;
}

function getShowTutorialVideo(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].tutorialVideoUrl
    : false;
}

function getIdeProjectLogo(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].logo
    : pythonLogo;
}

function getIdeProjectRoute(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].route
      ? projectStackMetaMapping[projectStack].route
      : false
    : false;
}

function getCurrentGreetingMessage() {
  const currentTime = new Date();
  const currentHour = currentTime.getHours();

  let greeting = "";
  let icon = "";

  if (currentHour < 12) {
    greeting = "Good Morning";
    icon = "sun";
  } else if (currentHour < 18) {
    greeting = "Good Afternoon";
    icon = "cloud-sun";
  } else {
    greeting = "Good Evening";
    icon = "moon";
  }

  return { greeting, icon };
}

function trackEvent(eventName, params) {
  params.user_login_id = global_var.user_login_id;
  params.user_name = global_var.user_name;
  params.role_name = global_var.role_name;
  params.company_id = global_var.company_id;
  params.company_name = global_var.company_name;
  ReactGA.event(eventName, params);
}
let isMobile = false;
function isMobileDevice() {
  if(window.innerWidth <= 767){
    isMobile = true
  }
}
isMobileDevice()
function getCssClassNameForAutoSize(
  component,
  fileManagerExpanded,
  outputWindowExpanded
) {
  if (isMobile) {
    fileManagerExpanded = false;
  }
  
  if (component === "code-editor") {
    if (!fileManagerExpanded && outputWindowExpanded) {
      return "col-md-6 col-11";
    } else {
      return outputWindowExpanded ? "col-11 col-md-7" : "col";
    }
  } else if (component === "output-window") {
    if (!outputWindowExpanded) {
      return "d-none";
    } else {
      return fileManagerExpanded ? "col-11 col-md-5" : "col-11 col-md-6";
    }
  } else if (component === "file-manager") {
    if (isMobile) {
      return "d-none";
    }
    return fileManagerExpanded ? "col-3 col-md-2 border-end" : "d-none";
  } else if (component === "code-editor-output-container") {
    return fileManagerExpanded ? "col-md-10 col-9" : "col";
  }
}

export {
  getFileExtension,
  formatDate,
  getIdeProjectLogo,
  getIdeProjectRoute,
  getCurrentGreetingMessage,
  getEvaluationStatusColor,
  getIdeProjectTypeMetaData,
  getShowMyProjectFlag,
  getShowTutorialVideo,
  trackEvent,
  getCssClassNameForAutoSize,
  getEvaluationStatusName,
  isMobile,
  formatDateMonth,
};
